import type { ReactNode } from 'react';

// Use in cases where we need a component that does nothing
export function EmptyComponent(): ReactNode {
	return null;
}
